import AppStoreContext, { IAppStoreContext } from "@myinnsworth/contexts/AppStoreContext";
import { ICountry } from "@myinnsworth/models/address/ICountry";
import { IApplicant } from "@myinnsworth/models/applicants/IApplicant";
import ICase from "@myinnsworth/models/case/ICase";
import { useContext } from "react";

interface IUseAppStoreResult {
    cases: Array<ICase>;
    findCase: (slug: string) => ICase | undefined;
    countries: Array<ICountry>;
    currentApplicant?: IApplicant;
    setCurrentApplicant: (applicant: IApplicant) => void;
}


export function useAppStore(): IUseAppStoreResult {
    const ctx = useContext<IAppStoreContext>(AppStoreContext);
    
    return {
        cases: ctx.cases,
        findCase: (slug: string): ICase | undefined => {
            return ctx.cases.find(x => x.slug === slug);
        },
        countries: ctx.countries,
        currentApplicant: ctx.currentApplicant,
        setCurrentApplicant: ctx.setCurrentApplicant
    };
}